"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VNButtonContainer = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _VNButton = require("./VNButton");
var _styles = require("@material-ui/core/styles");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
/**
 * @param {Function} onClick Handle the onClick event.
 * @param {Boolean} defaultSelected if no buttons are selected the first will be selected
 * @param {Array} buttons a 2d array of objects. Each nested array's length will be how many buttons show up in a row.
 * inside of the nested array will contain objects, these objects are used for styling that specific button.
 *      @param {String} buttonVariant the style that is in the mui theme
 *      @param {String} padding padding around object
 *      @param {String} title title of each object
 *      @param {String} id the id that will be returned to the user when an object is clicked.
 *      @param {Boolean} selected the first one to be selected.
 */
var VNButtonContainer = function VNButtonContainer(props) {
  var _useState = (0, _react.useState)(props.defaultSelected ? "0-0" : null),
    _useState2 = (0, _slicedToArray2.default)(_useState, 2),
    selected = _useState2[0],
    setSelected = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
    defaultSelected = _useState4[0],
    setDefaultSelected = _useState4[1];
  var buttons = {};
  var theme = (0, _styles.useTheme)();
  var renderArray = function renderArray() {
    return props.buttons.map(function (nestedButtons, xIndex) {
      return /*#__PURE__*/_react.default.createElement("div", {
        key: "row-".concat(xIndex),
        style: {
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center'
        }
      }, nestedButtons.map(function (button, yIndex) {
        if (button?.selected && !defaultSelected) {
          setDefaultSelected(true);
          setSelected("".concat(xIndex, "-").concat(yIndex));
        }
        buttons["".concat(xIndex, "-").concat(yIndex)] = selected === "".concat(xIndex, "-").concat(yIndex) ? true : false;
        return /*#__PURE__*/_react.default.createElement("div", {
          key: "".concat(xIndex, "-").concat(yIndex),
          id: "".concat(xIndex, "-").concat(yIndex),
          style: {
            padding: button.padding ? button.padding : theme.custom.defaultPadding,
            flexGrow: 1
          }
        }, /*#__PURE__*/_react.default.createElement(_VNButton.VNButton, {
          color: 'secondary',
          onClick: function onClick() {
            setSelected("".concat(xIndex, "-").concat(yIndex));
            props.onClick(button.id);
          },
          text: button.title,
          disableRipple: button.disableRipple ? button.disableRipple : false,
          buttonVariant: button.buttonVariant,
          variant: buttons["".concat(xIndex, "-").concat(yIndex)] ? 'contained' : 'outlined',
          fullWidth: false
        }));
      }));
    });
  };
  return renderArray();
};
exports.VNButtonContainer = VNButtonContainer;